import { type AuthUser, getCurrentUser } from 'aws-amplify/auth';

export const getAuthentication = async (): Promise<AuthUser | boolean> => {
  try {
    const { username, userId, signInDetails } = await getCurrentUser();
    return { username, userId, signInDetails };
  } catch (e) {
    return false;
  }
};
